var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenInNewWindow = function SvgOpenInNewWindow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.998 15.335A1.333 1.333 0 0 0 15.332 14v-12A1.333 1.333 0 0 0 13.998.668h-12A1.333 1.333 0 0 0 .665 2.001v4.667a.667.667 0 1 0 1.333 0V2.001h12v12H9.332a.666.666 0 1 0 0 1.334zm-4-8.667v4a.667.667 0 0 1-1.333 0v-2.39L1.804 15.14a.668.668 0 0 1-.944-.944l6.862-6.861h-2.39a.667.667 0 1 1 0-1.334h4a.667.667 0 0 1 .666.663",
    clipRule: "evenodd"
  })));
};
export default SvgOpenInNewWindow;